const updateStatusVerificationItems = {
  toastr: 'Tipo de Serviço atualizado',
  toastr1: ' foi atualizado com sucesso',
  toastrError: 'Tipo de Serviço já cadastrado',
  toastrError: 'Insira outro nome'
};

export default updateStatusVerificationItems;
